import React, { Component } from 'react';
import PropTypes from 'prop-types';

class TitleAndDescription extends Component {
  render() {
    var { titleFont, title, description } = this.props;
    var titleComponent = null,
      descriptionComponent = null;
    switch (titleFont) {
      case 24:
        titleComponent = <h3>{title}</h3>;
        break;
      case 15:
        titleComponent = <h5>{title}</h5>;
        break;
      case 18:
        titleComponent = <h4>{title}</h4>;
        break;
    }

    descriptionComponent = <span className="description">{description}</span>;

    return (
      <div className="title-and-description">
        {titleComponent}
        {descriptionComponent}
      </div>
    );
  }
}

TitleAndDescription.propTypes = {
  titleFont: PropTypes.oneOf([24, 15]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

TitleAndDescription.defaultProps = {
  titleFont: 15
};

TitleAndDescription.displayName = 'TitleAndDescription';

export default TitleAndDescription;
